/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Card,
  Grid,
  TextField,
  Toolbar,
  CircularProgress,
  Paper,
  Backdrop,
} from "@material-ui/core";
import BottomBar from "../../../components/BottomBar/BottomBar";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import { IsEmpty } from "../../../utils/helper";
import { DatePicker } from "@material-ui/pickers";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

const useStyles = (theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 0, 2),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  cardContentDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: 70,
    marginBottom: 10,
    overFlow: "hidden",
  },
  contentContainer: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
  },
  contentContainerSM: {
    alignItems: "center",
    textAlign: "center",
    width: "65%",
    marginLeft: 10,
    marginRight: 5,
  },
  tableSubHeaderRowRow: {
    background: "#4e7cb899",
    color: "white !important",
    fontWeight: 600,
  },
  tableSubHeaderCell: {
    background: "#4e7cb899",
    color: "white !important",
    fontWeight: 200,
  },
});

const TextFieldInList = ({
  id,
  name,
  label,
  initialPrice,
  disabled,
  maxPrice,
  error = false,
  recordId = 0,
  externalValue,
}) => {
  const [priceVal, setPriceVal] = useState(initialPrice);
  const [tempVal, setTempVal] = useState(initialPrice);
  const [localError, setLocalError] = useState(error);

  useEffect(() => {
    setPriceVal(initialPrice);
    setTempVal(initialPrice);
  }, [initialPrice]);

  // When parent pushes a percentage-computed value, override tempVal
  useEffect(() => {
    if (externalValue !== undefined && externalValue !== null) {
      const clamped = parseFloat(Math.min(Number(externalValue), Number(maxPrice)).toFixed(2));
      setTempVal(clamped);
      setPriceVal(clamped);
      setLocalError(clamped > Number(maxPrice));
    } else {
      // When externalValue is cleared (undefined), reset to initialPrice
      setTempVal(initialPrice);
      setPriceVal(initialPrice);
      setLocalError(false);
    }
  }, [externalValue]);

  const handleChange = (id, event) => {
    const newValue = event.target.value;

    // Always update temp value
    setTempVal(newValue);

    if (recordId !== 0) {
      if (Number(newValue) <= maxPrice) {
        setPriceVal(newValue);
        setLocalError(false);
      } else {
        setLocalError(true);
      }
    } else {
      if (Number(newValue) <= maxPrice) {
        setPriceVal(newValue);
        setLocalError(false);
      } else {
        setLocalError(true);
      }
    }
  };

  // Calculate after discount price (ensure it's never negative) with 2 decimal places
  const discountAmount = Math.min(Number(tempVal), Number(maxPrice));
  const afterDiscountValue = Number(maxPrice) - discountAmount;
  const afterDiscountPrice = parseFloat(afterDiscountValue.toFixed(2));

  return (
    <div>
      <TextField
        id={id}
        name={name}
        label={label}
        variant="outlined"
        value={tempVal}
        onChange={(e) => handleChange(id, e)}
        style={{ margin: '10px', width: '80%' }}
        fullWidth
        disabled={disabled}
        type="number"
        error={localError}
        helperText={localError ? 'Discount cannot be greater than price' : ''}
      />
      <div style={{ marginLeft: '10px', fontSize: '0.9rem' }}>
        <div>
          <b>After Discount: </b>
          <span style={{ color: '#4caf50', fontWeight: 'bold' }}>
            {Number(maxPrice) > 0 && !disabled ? afterDiscountPrice : '0'}
          </span>
        </div>
      </div>
    </div>
  );
};

class F301GeneralDiscountFormV4 extends React.Component {
  constructor(props) {
    super(props);
    const ckAdminObject = localStorage.getItem("ckAdminUser") || "{}";
    const ckAdminJsonObject = JSON.parse(ckAdminObject) || {};
    const storedToken = ckAdminJsonObject.jwttoken || "";

    this.state = {
      recordId: this.props.match.params.recordId,
      isLoading: false,
      isDataLoading: false,
      priceLabel: "",
      priceListId: "",
      discountCategoriesList: [],
      selectedPriceCategoriesList: [],
      discountCategoryProductList: [],
      selectedPriceCategoriesProductList: [],
      isPriceReadyToSubmit: false,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      token: storedToken,
      effectiveFrom: new Date(),
      effectiveTo: this.getNextMonthDate(),
      textFields: {},
      isLoginMenu: false,
      isReload: true,
      isSubmitLoading: false,
      discountPercent: "", // NEW: global discount percentage
    };
  }

  getNextMonthDate() {
    let today = new Date();
    let currentYear = today.getFullYear();
    let currentMonth = today.getMonth();
    let currentDay = today.getDate();

    let nextMonth = new Date(currentYear, currentMonth + 1, currentDay);

    if (nextMonth.getMonth() !== (currentMonth + 1) % 12) {
      nextMonth = new Date(currentYear, currentMonth + 1, 0);
    }

    return nextMonth;
  }

  getTomorrowDate = () => {
    let a = new Date();
    a.setDate(a.getDate() + 1);
    return a;
  };

  componentDidMount() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    const id = this.props.match.params.recordId;
    if (id != 0) {
      this.setState({
        recordId: id,
      });
      this.getPriceCategoriesData(id);
    } else {
      this.getPriceCategoriesData(0);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.match.params.recordId != nextProps.match.params.recordId) {
      if (nextProps.match.params.recordId != 0) {
        this.getData(nextProps.match.params.recordId);
      } else {
        window.location.reload();
      }
    }
  }

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  getData = async (index) => {
    const data = new FormData();

    data.append("", index);
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C303CommonProductsViewV2?&recordId=${index}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        let vouchersData = res.data[0];

        let dateFrom = vouchersData.effectiveFrom;
        let dateTo = vouchersData.effectiveTo;

        this.setState({
          Data: res.data || [],
          priceLabel: vouchersData.priceLabel,
          selectedPriceCategoriesProductList: vouchersData.isSelectedAll
            ? []
            : vouchersData.productId,

          effectiveFrom: dateFrom,
          effectiveTo: dateTo,

          selectedPriceCategoriesList: vouchersData.categoryId,
        });
      }
    }
  };

  setPriceCategoryV2 = async (e) => {
    this.state.selectedPriceCategoriesList = [];
    await this.setState({
      selectedPriceCategoriesList: e,
    });
    this.getPriceCategoriesProductData(e);
  };

  getPriceCategoriesData = async () => {
    this.setState({
      isDataLoading: true,
    });

    const data = new FormData();
    data.append("recordId", this.state.recordId);
    const res = await HttpRequest(
      "Post",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C301CommonProductsViewV3`,
      data,
      "authorize"
    );
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        if (this.state.recordId == 0) {
          this.setState({
            discountCategoriesList: res.data,
            priceListId: res.data[0].priceListId,
          });
        } else {
          this.setState({
            discountCategoriesList: res.data,
            priceLabel: res.data[0].discountListLabel,
            effectiveFrom: res.data[0].fromDate,
            effectiveTo: res.data[0].toDate,
            priceListId: res.data[0].priceListId,
          });
        }
      } else {
        this.setState({
          discountCategoriesList: [],
          priceLabel: "",
          priceListId: "",
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    this.setState({
      isDataLoading: false,
    });
  };

  getPriceCategoriesProductData = async (selectedPriceCategoriesList) => {
    if (selectedPriceCategoriesList.length > 0) {
      const data = new FormData();
      for (let i = 0; i < selectedPriceCategoriesList.length; i++) {
        data.append("categoryId", selectedPriceCategoriesList[i].id);
      }
      data.append("recordId", this.state.recordId);
      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C303CommonProductsViewV2`,
        data,
        "authorize"
      );
      if (res.isSuccess) {
        if (res.data != null && res.data.length > 0) {
          this.setState({
            discountCategoryProductList: res.data,
          });
        }
      }
    } else {
      this.setState({
        discountCategoryProductList: [],
      });
    }
  };

  handleTextFieldChange = (fieldId, value) => {
    this.setState((prevState) => ({
      textFields: {
        ...prevState.textFields,
        [fieldId]: value,
      },
    }));
  };

  initializeTextFields = (categories) => {
    const textFields = {};
    categories.forEach((category) => {
      category.productAttributes[0].sizes.forEach((size) => {
        textFields[`${category.categoryId}_${size.id}`] = "";
      });
    });
    this.setState({ textFields });
  };

  renderDynamicTextFields = () => {
    const { textFields } = this.state;
    return Object.keys(textFields).map((fieldId) => (
      <TextField
        key={fieldId}
        id={`textfield-${fieldId}`}
        label={`Field ${fieldId}`}
        variant="outlined"
        value={textFields[fieldId]}
        onChange={(e) => this.handleTextFieldChange(fieldId, e.target.value)}
        style={{ margin: "10px" }}
      />
    ));
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    const errorName = `${name}Error`;
    let errorMsg = "";

    this.setState((state) => ({
      ...state,
      [name]: value,
      [errorName]: errorMsg,
    }));
  };

  // NEW: Compute discount amount from global percentage for a given actual price
  getComputedDiscount = (actualPrice) => {
    const pct = this.state.discountPercent;
    if (pct === "" || pct === null || pct === undefined || Number(actualPrice) <= 0) {
      return undefined;
    }
    return parseFloat((Number(actualPrice) * (Number(pct) / 100)).toFixed(2));
  };

  submitPrice = async () => {
    const jsonPayload = {};
    const priceLabel = this.state.priceLabel;

    if (IsEmpty(priceLabel)) {
      this.handleSnackbar(true, "Please add discount label.", "error");
      return false;
    }

    const effectiveFrom = document.getElementById("effectiveFrom").value;
    const effectiveTo = document.getElementById("effectiveTo").value;

    for (let i = 0; i < document.getElementsByName("categoryId").length; i++) {
      let categoryLabel = document.getElementsByName("categoryLabel")[i].value;
      let categoryId = document.getElementsByName("categoryId")[i].value;
      if (!jsonPayload[categoryId]) {
        jsonPayload[categoryId] = {
          categoryId: categoryId,
          recordId: this.state.recordId,
          priceLabel: priceLabel,
          fromDate: effectiveFrom,
          toDate: effectiveTo,
          priceListId: this.state.priceListId,
          sizes: [],
          bundles: [],
          styles: [],
          pages: [],
          covers: [],
          lamination: [],
          packaging: [],
        };
      }

      let categorySizesArray = document.getElementsByName(
        categoryId + ":sizeId"
      );

      for (let j = 0; j < categorySizesArray.length; j++) {
        let sizeId = categorySizesArray[j].value;
        let sizePrice = parseFloat(document.getElementById(
          categoryId + "_" + sizeId + "_size"
        ).value) || 0;
        let actualSizePrice = parseFloat(document.getElementById(
          categoryId + "_" + sizeId + "_size_actual_price"
        ).value) || 0;
        let sizeInputId = categoryId + "_" + sizeId + "_size";

        if (sizePrice > actualSizePrice) {
          this.handleSnackbar(true, `Discount of ${categoryLabel}' size cannot exceed actual price.`, "error");
          document.getElementById(sizeInputId).focus();
          return;
        }

        let sizeobject = { sizeId: sizeId, sizePrice: sizePrice };
        jsonPayload[categoryId].sizes.push(sizeobject);
      }

      let categoryBundleArray = document.getElementsByName(
        categoryId + ":bundleId"
      );

      for (let j = 0; j < categoryBundleArray.length; j++) {
        let productId = categoryBundleArray[j].value;
        let productPrice = parseFloat(document.getElementById(
          productId + "_product"
        ).value) || 0;
        let actualProductPrice = parseFloat(document.getElementById(
          productId + "_product_actual_price"
        ).value) || 0;
        let productInputId = productId + "_product";
        if (productPrice > actualProductPrice) {
          this.handleSnackbar(true, `Discount of ${categoryLabel}' bundle cannot exceed actual price.`, "error");
          document.getElementById(productInputId).focus();
          return;
        }

        let bundleObject = { productId: productId, productPrice: productPrice };
        jsonPayload[categoryId].bundles.push(bundleObject);
      }

      let categorypageTypesArray = document.getElementsByName(
        categoryId + ":productStyleId"
      );
      for (let j = 0; j < categorypageTypesArray.length; j++) {
        let productId = categorypageTypesArray[j].value;
        let price = parseFloat(document.getElementById(productId + "_product").value) || 0;
        let actualPrice = parseFloat(document.getElementById(productId + "_product_actual_price").value) || 0;

        let productInputId = productId + "_product";
        if (price > actualPrice) {
          this.handleSnackbar(true, `Discount of ${categoryLabel}' style cannot exceed actual price.`, "error");
          document.getElementById(productInputId).focus();
          return;
        }

        let object = { productId: productId, productPrice: price };
        jsonPayload[categoryId].styles.push(object);
      }

      let categoryPageNumbersArray = document.getElementsByName(
        categoryId + ":pageNumberId"
      );
      for (let j = 0; j < categoryPageNumbersArray.length; j++) {
        let productId = categoryPageNumbersArray[j].value;
        let price = parseFloat(document.getElementById(productId + "_product").value) || 0;
        let actualPrice = parseFloat(document.getElementById(productId + "_product_actual_price").value) || 0;

        let productInputId = productId + "_product";
        if (price > actualPrice) {
          this.handleSnackbar(true, `Discount of ${categoryLabel}' pages cannot exceed actual price.`, "error");
          document.getElementById(productInputId).focus();
          return;
        }

        let object = { productId: productId, productPrice: price };
        jsonPayload[categoryId].pages.push(object);
      }

      let categoryCoverArray = document.getElementsByName(
        categoryId + ":coverId"
      );

      for (let j = 0; j < categoryCoverArray.length; j++) {
        let productId = categoryCoverArray[j].value;
        let price = parseFloat(document.getElementById(productId + "_product").value) || 0;
        let actualPrice = parseFloat(document.getElementById(productId + "_product_actual_price").value) || 0;

        let productInputId = productId + "_product";
        if (price > actualPrice) {
          this.handleSnackbar(true, `Discount of ${categoryLabel}' cover cannot exceed actual price.`, "error");
          document.getElementById(productInputId).focus();
          return;
        }

        let object = { productId: productId, productPrice: price };
        jsonPayload[categoryId].covers.push(object);
      }

      let categoryPackagingArray = document.getElementsByName(
        categoryId + ":packagingId"
      );

      for (let j = 0; j < categoryPackagingArray.length; j++) {
        let productId = categoryPackagingArray[j].value;
        let productPrice = parseFloat(document.getElementById(
          productId + "_product"
        ).value) || 0;
        let actualProductPrice = parseFloat(document.getElementById(
          productId + "_product_actual_price"
        ).value) || 0;

        let productInputId = productId + "_product";
        if (productPrice > actualProductPrice) {
          this.handleSnackbar(true, `Discount of ${categoryLabel}' packaging cannot exceed actual price.`, "error");
          document.getElementById(productInputId).focus();
          return;
        }
        let object = { productId: productId, productPrice: productPrice };
        jsonPayload[categoryId].packaging.push(object);
      }

      let categoryLaminationArray = document.getElementsByName(
        categoryId + ":laminationId"
      );

      for (let j = 0; j < categoryLaminationArray.length; j++) {
        let productId = categoryLaminationArray[j].value;
        let price = parseFloat(document.getElementById(productId + "_product").value) || 0;
        let actualPrice = parseFloat(document.getElementById(productId + "_product_actual_price").value) || 0;

        let productInputId = productId + "_product";
        if (price > actualPrice) {
          this.handleSnackbar(true, `Discount of ${categoryLabel}' lamination cannot exceed actual price.`, "error");
          document.getElementById(productInputId).focus();
          return;
        }

        let object = { productId: productId, productPrice: price };
        jsonPayload[categoryId].lamination.push(object);
      }
    }

    const jsonString = JSON.stringify(Object.values(jsonPayload));
    this.setState({
      isSubmitLoading: true,
    });
    // Send the JSON payload
    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C301CommonProductsDiscountSave`,
      jsonString,
      "authorizeJson"
    );

    if (res.isSuccess) {
      // this.setState({
      //   isLoading: false,
      // });
      this.handleSnackbar(true, "Saved", "success");
      window.location.reload();
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
          isLoading: false,
        });
      } else {
        // this.setState({
        //   isLoading: false,
        // });
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      isSubmitLoading: false,
    });
  };

  setEffectiveFrom = (date) => {
    this.setState({ effectiveFrom: date });
  };

  setEffectiveTo = (date) => {
    this.setState({ effectiveTo: date });
  };

  viewReport = async () => {
    window.location = "#/F301GeneralDiscountReport";
  };

  render() {
    const { classes } = this.props;
    let { discountCategoriesList = [] } = this.state;
    let screenHeight = window.screen.height;

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <Grid
          container
          direction={"column"}
          justifyContent="center"
          alignItems="center"
          style={{ padding: 10 }}
        >
          <Toolbar>
            <NavBar isAuthorize title="Discount Pricing" />
          </Toolbar>
          <Card
            style={{
              width: "98%",
              height: "auto",
              paddingTop: 20,
              paddingBottom: 100,
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            <form id="myForm" style={{ minHeight: screenHeight }}>
              {/* Discount Label */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  marginBottom: "20px",
                }}
              >
                <Grid container spacing={2} alignItems={"flex-start"}>
                  <Grid item xs={6}>
                    <TextField
                      id="discount-label"
                      name="priceLabel"
                      value={this.state.priceLabel}
                      fullWidth
                      label="Discount Label"
                      variant="outlined"
                      onChange={this.handleChange}
                    />
                  </Grid>
                </Grid>
              </div>

              {/* Effective Dates */}
              <Grid container spacing={2} alignItems={"flex-start"}>
                <Grid container item xs={6}>
                  <DatePicker
                    format="dd-MM-yyyy"
                    autoOk
                    label="Effective from"
                    id="effectiveFrom"
                    value={this.state.effectiveFrom}
                    onChange={this.setEffectiveFrom}
                    required
                    fullWidth
                    inputVariant="outlined"
                  />
                </Grid>
                <Grid container item xs={6}>
                  <DatePicker
                    format="dd-MM-yyyy"
                    autoOk
                    label="Effective To"
                    id="effectiveTo"
                    value={this.state.effectiveTo}
                    onChange={this.setEffectiveTo}
                    required
                    fullWidth
                    inputVariant="outlined"
                  />
                </Grid>
              </Grid>

              {/* ── NEW: Global Discount Percentage ── */}
              <Grid
                container
                spacing={2}
                alignItems="center"
                style={{
                  marginTop: 20,
                  marginBottom: 8,
                  padding: "16px 12px",
                  background: "#fffbf2",
                  border: "1px solid #f5c842",
                  borderRadius: 8,
                }}
              >
                <Grid item xs={12}>
                  <span style={{ fontWeight: 600, fontSize: "0.95rem", color: "#7a5c00" }}>
                    Apply Global Discount %
                  </span>
                  <span style={{ fontSize: "0.82rem", color: "#999", marginLeft: 10 }}>
                    Enter a percentage to auto-fill all discount fields
                  </span>
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    id="global-discount-percent"
                    name="discountPercent"
                    label="Discount %"
                    variant="outlined"
                    type="number"
                    fullWidth
                    value={this.state.discountPercent}
                    inputProps={{ min: 0, max: 100, step: 0.1 }}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || (Number(val) >= 0 && Number(val) <= 100)) {
                        this.setState({ discountPercent: val });
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <span style={{ color: "#888", marginRight: 8, fontWeight: 600 }}>%</span>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={2}>
                  <button
                    type="button"
                    onClick={() => this.setState({ discountPercent: "" })}
                    style={{
                      padding: "14px 20px",
                      background: "#f5f5f5",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      cursor: "pointer",
                      fontSize: "0.9rem",
                      color: "#555",
                    }}
                  >
                    Clear
                  </button>
                </Grid>

                {this.state.discountPercent !== "" && (
                  <Grid item xs={7}>
                    <span
                      style={{
                        color: "#1976d2",
                        fontSize: "0.9rem",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span style={{ fontSize: "1rem" }}>✓</span>
                      <b>{this.state.discountPercent}%</b> discount is being applied to all fields
                    </span>
                  </Grid>
                )}
              </Grid>
              {/* ── END: Global Discount Percentage ── */}

              <div style={{ width: "100%", marginBottom: 20, marginTop: 20 }}>
                {this.state.isDataLoading ? (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <TableContainer component={Paper}>
                    {discountCategoriesList.map((row) => (
                      <Table key={row} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell
                              align="left"
                              style={{
                                background: "rgb(250 178 70)",
                                color: "white",
                              }}
                            >
                              {row.categoryLabel}
                              <input
                                name={"categoryId"}
                                value={row.categoryId}
                                type="hidden"
                              />
                              <input
                                name={"categoryLabel"}
                                value={row.categoryLabel}
                                type="hidden"
                              />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {/* Sizes Started */}
                          <TableRow>
                            <TableCell>
                              <Table
                                style={{
                                  border: "1px solid rgb(224 224 224)",
                                  borderBottom: "1px solid rgb(224 224 224)",
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow className={classes.tableSubHeaderRow}>
                                    <TableCell
                                      align="left"
                                      className={classes.tableSubHeaderCell}
                                    >
                                      Sizes{" "}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell align="left">
                                      <Table
                                        style={{
                                          border: "1px solid rgb(224 224 224)",
                                        }}
                                        aria-label="simple table"
                                      >
                                        <TableHead>
                                          <TableRow>
                                            {row.productAttributes[0].sizes.map(
                                              (size) => (
                                                <TableCell key={size} align="left">
                                                  {size.userLabel}{" "}
                                                </TableCell>
                                              )
                                            )}
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          <TableRow>
                                            {row.productAttributes[0].sizes.map(
                                              (size, sizeIndex) => (
                                                <TableCell align="left" key={sizeIndex}>
                                                  <>
                                                    <input
                                                      type="hidden"
                                                      id={`${row.categoryId}_${size.id}_size_actual_price`}
                                                      name={`${row.categoryId}_${size.id}_size_actual_price`}
                                                      value={size.price}
                                                    />
                                                    <input
                                                      type="hidden"
                                                      name={`${row.categoryId}:sizeId`}
                                                      value={size.id}
                                                    />
                                                    <div>
                                                      <b>Actual Price: </b> {size.price}
                                                    </div>
                                                    <TextFieldInList
                                                      key={sizeIndex + row.categoryId}
                                                      id={`${row.categoryId}_${size.id}_size`}
                                                      name={`${row.categoryId}_${size.id}_size`}
                                                      label="discount"
                                                      disabled={(size.price <= 0 && size.discount <= size.price) ? true : false}
                                                      error={size.discount > size.price}
                                                      maxPrice={size.price}
                                                      initialPrice={size.discount}
                                                      recordId={this.state.recordId}
                                                      externalValue={this.getComputedDiscount(size.price)}
                                                    />
                                                  </>
                                                </TableCell>
                                              )
                                            )}
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableCell>
                          </TableRow>
                          {/* Sizes Ended */}

                          {/* Page Styles for Custom Photobook (categoryId == 1) */}
                          {row.categoryId == 1 ? (
                            <>
                              {/* Pages Types Started */}
                              <TableRow>
                                <TableCell>
                                  <Table
                                    style={{
                                      border: "1px solid rgb(224 224 224)",
                                      borderBottom: "1px solid rgb(224 224 224)",
                                    }}
                                    aria-label="simple table"
                                  >
                                    <TableHead>
                                      <TableRow className={classes.tableSubHeaderRow}>
                                        <TableCell
                                          className={classes.tableSubHeaderCell}
                                          align="left"
                                        >
                                          {"Page Styles"}{" "}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="left">
                                          <Table
                                            style={{ border: "1px solid rgb(224 224 224)" }}
                                            aria-label="simple table"
                                          >
                                            {row.productAttributes[0].styles.map(
                                              (styles, pageTypesIndex) => {
                                                return (
                                                  <>
                                                    {pageTypesIndex % 4 === 0 ? (
                                                      <>
                                                        <TableHead>
                                                          <TableRow>
                                                            <TableCell align="left">
                                                              {row.productAttributes[0].styles[pageTypesIndex].userLabel}{" "}
                                                            </TableCell>
                                                            {pageTypesIndex + 1 < row.productAttributes[0].styles.length ? (
                                                              <TableCell align="left">
                                                                {row.productAttributes[0].styles[pageTypesIndex + 1].userLabel}{" "}
                                                              </TableCell>
                                                            ) : (<span />)}
                                                            {pageTypesIndex + 2 < row.productAttributes[0].styles.length ? (
                                                              <TableCell align="left">
                                                                {row.productAttributes[0].styles[pageTypesIndex + 2].userLabel}{" "}
                                                              </TableCell>
                                                            ) : (<span />)}
                                                            {pageTypesIndex + 3 < row.productAttributes[0].styles.length ? (
                                                              <TableCell align="left">
                                                                {row.productAttributes[0].styles[pageTypesIndex + 3].userLabel}{" "}
                                                              </TableCell>
                                                            ) : (<span />)}
                                                          </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                          <TableRow>
                                                            <TableCell align="left">
                                                              <input type="hidden" id={`${styles.productId}_product_actual_price`} name={`${styles.productId}_product_actual_price`} value={styles.price} />
                                                              <input type="hidden" name={`${row.categoryId}:productStyleId`} value={styles.productId} />
                                                              <div><b>Actual Price: </b> {styles.price}</div>
                                                              <TextFieldInList
                                                                key={pageTypesIndex + row.categoryId}
                                                                id={`${styles.productId}_product`}
                                                                name={`${styles.productId}_product`}
                                                                label="discount"
                                                                disabled={(styles.price <= 0 && styles.discount <= styles.price) ? true : false}
                                                                error={styles.discount > styles.price}
                                                                maxPrice={styles.price}
                                                                initialPrice={styles.discount}
                                                                recordId={this.state.recordId}
                                                                externalValue={this.getComputedDiscount(styles.price)}
                                                              />
                                                            </TableCell>
                                                            {pageTypesIndex + 1 < row.productAttributes[0].styles.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAttributes[0].styles[pageTypesIndex + 1].productId}_product_actual_price`} name={`${row.productAttributes[0].styles[pageTypesIndex + 1].productId}_product_actual_price`} value={row.productAttributes[0].styles[pageTypesIndex + 1].price || 0} />
                                                                <input type="hidden" name={`${row.categoryId}:productStyleId`} value={row.productAttributes[0].styles[pageTypesIndex + 1].productId} />
                                                                <div><b>Actual Price: </b> {row.productAttributes[0].styles[pageTypesIndex + 1].price || 0}</div>
                                                                <TextFieldInList
                                                                  key={pageTypesIndex + 1 + row.categoryId}
                                                                  recordId={this.state.recordId}
                                                                  id={`${row.productAttributes[0].styles[pageTypesIndex + 1].productId}_product`}
                                                                  name={`${row.productAttributes[0].styles[pageTypesIndex + 1].productId}_product`}
                                                                  disabled={(row.productAttributes[0].styles[pageTypesIndex + 1].price <= 0 && row.productAttributes[0].styles[pageTypesIndex + 1].discount <= row.productAttributes[0].styles[pageTypesIndex + 1].price) ? true : false}
                                                                  error={row.productAttributes[0].styles[pageTypesIndex + 1].discount > row.productAttributes[0].styles[pageTypesIndex + 1].price}
                                                                  maxPrice={row.productAttributes[0].styles[pageTypesIndex + 1].price}
                                                                  label="discount"
                                                                  initialPrice={row.productAttributes[0].styles[pageTypesIndex + 1].discount}
                                                                  externalValue={this.getComputedDiscount(row.productAttributes[0].styles[pageTypesIndex + 1].price)}
                                                                />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                            {pageTypesIndex + 2 < row.productAttributes[0].styles.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAttributes[0].styles[pageTypesIndex + 2].productId}_product_actual_price`} name={`${row.productAttributes[0].styles[pageTypesIndex + 2].productId}_product_actual_price`} value={row.productAttributes[0].styles[pageTypesIndex + 2].price} />
                                                                <input type="hidden" name={`${row.categoryId}:productStyleId`} value={row.productAttributes[0].styles[pageTypesIndex + 2].productId} />
                                                                <div><b>Actual Price: </b> {row.productAttributes[0].styles[pageTypesIndex + 2].price}</div>
                                                                <TextFieldInList
                                                                  recordId={this.state.recordId}
                                                                  key={pageTypesIndex + 2 + row.categoryId}
                                                                  id={`${row.productAttributes[0].styles[pageTypesIndex + 2].productId}_product`}
                                                                  name={`${row.productAttributes[0].styles[pageTypesIndex + 2].productId}_product`}
                                                                  disabled={(row.productAttributes[0].styles[pageTypesIndex + 2].price <= 0 && row.productAttributes[0].styles[pageTypesIndex + 2].discount <= row.productAttributes[0].styles[pageTypesIndex + 2].price) ? true : false}
                                                                  error={row.productAttributes[0].styles[pageTypesIndex + 2].discount > row.productAttributes[0].styles[pageTypesIndex + 2].price}
                                                                  maxPrice={row.productAttributes[0].styles[pageTypesIndex + 2].price}
                                                                  label="discount"
                                                                  initialPrice={row.productAttributes[0].styles[pageTypesIndex + 2].discount}
                                                                  externalValue={this.getComputedDiscount(row.productAttributes[0].styles[pageTypesIndex + 2].price)}
                                                                />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                            {pageTypesIndex + 3 < row.productAttributes[0].styles.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAttributes[0].styles[pageTypesIndex + 3].productId}_product_actual_price`} name={`${row.productAttributes[0].styles[pageTypesIndex + 3].productId}_product_actual_price`} value={row.productAttributes[0].styles[pageTypesIndex + 3].price} />
                                                                <input type="hidden" name={`${row.categoryId}:productStyleId`} value={row.productAttributes[0].styles[pageTypesIndex + 3].productId} />
                                                                <div><b>Actual Price: </b> {row.productAttributes[0].styles[pageTypesIndex + 3].price}</div>
                                                                <TextFieldInList
                                                                  recordId={this.state.recordId}
                                                                  key={pageTypesIndex + 3 + row.categoryId}
                                                                  id={`${row.productAttributes[0].styles[pageTypesIndex + 3].productId}_product`}
                                                                  name={`${row.productAttributes[0].styles[pageTypesIndex + 3].productId}_product`}
                                                                  disabled={(row.productAttributes[0].styles[pageTypesIndex + 3].price <= 0 && row.productAttributes[0].styles[pageTypesIndex + 3].discount <= row.productAttributes[0].styles[pageTypesIndex + 3].price) ? true : false}
                                                                  error={row.productAttributes[0].styles[pageTypesIndex + 3].discount > row.productAttributes[0].styles[pageTypesIndex + 3].price}
                                                                  maxPrice={row.productAttributes[0].styles[pageTypesIndex + 3].price}
                                                                  label="discount"
                                                                  initialPrice={row.productAttributes[0].styles[pageTypesIndex + 3].discount}
                                                                  externalValue={this.getComputedDiscount(row.productAttributes[0].styles[pageTypesIndex + 3].price)}
                                                                />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                          </TableRow>
                                                        </TableBody>
                                                      </>
                                                    ) : (<span />)}
                                                  </>
                                                );
                                              }
                                            )}
                                          </Table>
                                        </TableCell>
                                      </TableRow>

                                      <TableRow>
                                        <TableCell>
                                          <Table
                                            style={{
                                              border: "1px solid rgb(224 224 224)",
                                              borderBottom: "1px solid rgb(224 224 224)",
                                            }}
                                            aria-label="simple table"
                                          >
                                            <TableHead>
                                              <TableRow className={classes.tableSubHeaderRow}>
                                                <TableCell className={classes.tableSubHeaderCell} align="left">
                                                  {"Number of Pages"}{" "}
                                                </TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              <TableRow>
                                                <TableCell align="left">
                                                  <Table
                                                    style={{ border: "1px solid rgb(224 224 224)" }}
                                                    aria-label="simple table"
                                                  >
                                                    {row.productAttributes[0].pages.map(
                                                      (page, noOfPageIndex) => {
                                                        return (
                                                          <>
                                                            {noOfPageIndex % 4 === 0 ? (
                                                              <>
                                                                <TableHead>
                                                                  <TableRow>
                                                                    <TableCell align="left">{row.productAttributes[0].pages[noOfPageIndex].userLabel}{" "}</TableCell>
                                                                    {noOfPageIndex + 1 < row.productAttributes[0].pages.length ? (<TableCell align="left">{row.productAttributes[0].pages[noOfPageIndex + 1].userLabel}{" "}</TableCell>) : (<span />)}
                                                                    {noOfPageIndex + 2 < row.productAttributes[0].pages.length ? (<TableCell align="left">{row.productAttributes[0].pages[noOfPageIndex + 2].userLabel}{" "}</TableCell>) : (<span />)}
                                                                    {noOfPageIndex + 3 < row.productAttributes[0].pages.length ? (<TableCell align="left">{row.productAttributes[0].pages[noOfPageIndex + 3].userLabel}{" "}</TableCell>) : (<span />)}
                                                                  </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                  <TableRow>
                                                                    <TableCell align="left">
                                                                      <input type="hidden" id={`${page.productId}_product_actual_price`} name={`${page.productId}_product_actual_price`} value={page.price} />
                                                                      <input type="hidden" name={`${row.categoryId}:pageNumberId`} value={page.productId} />
                                                                      <div><b>Actual Price: </b> {page.price}</div>
                                                                      <TextFieldInList
                                                                        recordId={this.state.recordId}
                                                                        key={noOfPageIndex + row.categoryId}
                                                                        id={`${page.productId}_product`}
                                                                        name={`${page.productId}_product`}
                                                                        disabled={(page.price <= 0 && page.discount <= page.price) ? true : false}
                                                                        error={page.discount > page.price}
                                                                        maxPrice={page.price}
                                                                        label="discount"
                                                                        initialPrice={page.discount}
                                                                        externalValue={this.getComputedDiscount(page.price)}
                                                                      />
                                                                    </TableCell>
                                                                    {noOfPageIndex + 1 < row.productAttributes[0].pages.length ? (
                                                                      <TableCell align="left">
                                                                        <input type="hidden" id={`${row.productAttributes[0].pages[noOfPageIndex + 1].productId}_product_actual_price`} name={`${row.productAttributes[0].pages[noOfPageIndex + 1].productId}_product_actual_price`} value={row.productAttributes[0].pages[noOfPageIndex + 1].price} />
                                                                        <input type="hidden" name={`${row.categoryId}:pageNumberId`} value={row.productAttributes[0].pages[noOfPageIndex + 1].productId} />
                                                                        <div><b>Actual Price: </b> {row.productAttributes[0].pages[noOfPageIndex + 1].price}</div>
                                                                        <TextFieldInList
                                                                          recordId={this.state.recordId}
                                                                          key={noOfPageIndex + 1 + row.categoryId}
                                                                          id={`${row.productAttributes[0].pages[noOfPageIndex + 1].productId}_product`}
                                                                          name={`${row.productAttributes[0].pages[noOfPageIndex + 1].productId}_product`}
                                                                          disabled={(row.productAttributes[0].pages[noOfPageIndex + 1].price <= 0 && row.productAttributes[0].pages[noOfPageIndex + 1].discount <= row.productAttributes[0].pages[noOfPageIndex + 1].price) ? true : false}
                                                                          error={row.productAttributes[0].pages[noOfPageIndex + 1].discount > row.productAttributes[0].pages[noOfPageIndex + 1].price}
                                                                          maxPrice={row.productAttributes[0].pages[noOfPageIndex + 1].price}
                                                                          label="discount"
                                                                          initialPrice={row.productAttributes[0].pages[noOfPageIndex + 1].discount}
                                                                          externalValue={this.getComputedDiscount(row.productAttributes[0].pages[noOfPageIndex + 1].price)}
                                                                        />
                                                                      </TableCell>
                                                                    ) : (<span />)}
                                                                    {noOfPageIndex + 2 < row.productAttributes[0].pages.length ? (
                                                                      <TableCell align="left">
                                                                        <input type="hidden" id={`${row.productAttributes[0].pages[noOfPageIndex + 2].productId}_product_actual_price`} name={`${row.productAttributes[0].pages[noOfPageIndex + 2].productId}_product_actual_price`} value={row.productAttributes[0].pages[noOfPageIndex + 2].price} />
                                                                        <input type="hidden" name={`${row.categoryId}:pageNumberId`} value={row.productAttributes[0].pages[noOfPageIndex + 2].productId} />
                                                                        <div><b>Actual Price: </b> {row.productAttributes[0].pages[noOfPageIndex + 2].price}</div>
                                                                        <TextFieldInList
                                                                          recordId={this.state.recordId}
                                                                          key={noOfPageIndex + 2 + row.categoryId}
                                                                          id={`${row.productAttributes[0].pages[noOfPageIndex + 2].productId}_product`}
                                                                          name={`${row.productAttributes[0].pages[noOfPageIndex + 2].productId}_product`}
                                                                          disabled={(row.productAttributes[0].pages[noOfPageIndex + 2].price <= 0 && row.productAttributes[0].pages[noOfPageIndex + 2].discountt <= row.productAttributes[0].pages[noOfPageIndex + 2].price) ? true : false}
                                                                          error={row.productAttributes[0].pages[noOfPageIndex + 2].discount > row.productAttributes[0].pages[noOfPageIndex + 2].price}
                                                                          maxPrice={row.productAttributes[0].pages[noOfPageIndex + 2].price}
                                                                          label="discount"
                                                                          initialPrice={row.productAttributes[0].pages[noOfPageIndex + 2].discount}
                                                                          externalValue={this.getComputedDiscount(row.productAttributes[0].pages[noOfPageIndex + 2].price)}
                                                                        />
                                                                      </TableCell>
                                                                    ) : (<span />)}
                                                                    {noOfPageIndex + 3 < row.productAttributes[0].pages.length ? (
                                                                      <TableCell align="left">
                                                                        <input type="hidden" id={`${row.productAttributes[0].pages[noOfPageIndex + 3].productId}_product_actual_price`} name={`${row.productAttributes[0].pages[noOfPageIndex + 3].productId}_product_actual_price`} value={row.productAttributes[0].pages[noOfPageIndex + 3].price} />
                                                                        <input type="hidden" name={`${row.categoryId}:pageNumberId`} value={row.productAttributes[0].pages[noOfPageIndex + 3].productId} />
                                                                        <div><b>Actual Price: </b> {row.productAttributes[0].pages[noOfPageIndex + 3].price}</div>
                                                                        <TextFieldInList
                                                                          recordId={this.state.recordId}
                                                                          key={noOfPageIndex + 3 + row.categoryId}
                                                                          id={`${row.productAttributes[0].pages[noOfPageIndex + 3].productId}_product`}
                                                                          name={`${row.productAttributes[0].pages[noOfPageIndex + 3].productId}_product`}
                                                                          disabled={(row.productAttributes[0].pages[noOfPageIndex + 3].price <= 0 && row.productAttributes[0].pages[noOfPageIndex + 3].discountt <= row.productAttributes[0].pages[noOfPageIndex + 3].price) ? true : false}
                                                                          error={row.productAttributes[0].pages[noOfPageIndex + 3].discount > row.productAttributes[0].pages[noOfPageIndex + 3].price}
                                                                          maxPrice={row.productAttributes[0].pages[noOfPageIndex + 3].price}
                                                                          label="discount"
                                                                          initialPrice={row.productAttributes[0].pages[noOfPageIndex + 3].discount}
                                                                          externalValue={this.getComputedDiscount(row.productAttributes[0].pages[noOfPageIndex + 3].price)}
                                                                        />
                                                                      </TableCell>
                                                                    ) : (<span />)}
                                                                  </TableRow>
                                                                </TableBody>
                                                              </>
                                                            ) : (<span />)}
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                  </Table>
                                                </TableCell>
                                              </TableRow>
                                            </TableBody>
                                          </Table>
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableCell>
                              </TableRow>
                              {/* Pages Types Ended */}

                              {/* Covers Started */}
                              {row.categoryId == 1 && (
                                <TableRow>
                                  <TableCell>
                                    <Table style={{ border: "1px solid rgb(224 224 224)", borderBottom: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                      <TableHead>
                                        <TableRow className={classes.tableSubHeaderRow}>
                                          <TableCell align="left" className={classes.tableSubHeaderCell}>Covers{" "}</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell align="left">
                                            <Table style={{ border: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                              {row.productAddOns[0].cover.map((cover, coverIndex) => {
                                                return (
                                                  <>
                                                    {coverIndex % 4 === 0 ? (
                                                      <>
                                                        <TableHead>
                                                          <TableRow>
                                                            <TableCell align="left">{row.productAddOns[0].cover[coverIndex].userLabel}{" "}</TableCell>
                                                            {coverIndex + 1 < row.productAddOns[0].cover.length ? (<TableCell align="left">{row.productAddOns[0].cover[coverIndex + 1].userLabel}{" "}</TableCell>) : (<span />)}
                                                            {coverIndex + 2 < row.productAddOns[0].cover.length ? (<TableCell align="left">{row.productAddOns[0].cover[coverIndex + 2].userLabel}{" "}</TableCell>) : (<span />)}
                                                            {coverIndex + 3 < row.productAddOns[0].cover.length ? (<TableCell align="left">{row.productAddOns[0].cover[coverIndex + 3].userLabel}{" "}</TableCell>) : (<span />)}
                                                          </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                          <TableRow>
                                                            <TableCell align="left">
                                                              <input type="hidden" id={`${cover.productId}_product_actual_price`} name={`${cover.productId}_product_actual_price`} value={cover.price} />
                                                              <input type="hidden" name={`${row.categoryId}:coverId`} value={cover.productId} />
                                                              <div>Actual Price: {cover.price}</div>
                                                              <TextFieldInList
                                                                recordId={this.state.recordId}
                                                                key={coverIndex + row.categoryId}
                                                                id={`${cover.productId}_product`}
                                                                name={`${cover.productId}_product`}
                                                                disabled={(cover.price <= 0 && cover.discount <= cover.price) ? true : false}
                                                                error={cover.discount > cover.price}
                                                                maxPrice={cover.price}
                                                                label="discount"
                                                                initialPrice={cover.discount}
                                                                externalValue={this.getComputedDiscount(cover.price)}
                                                              />
                                                            </TableCell>
                                                            {coverIndex + 1 < row.productAddOns[0].cover.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAddOns[0].cover[coverIndex + 1].productId}_product_actual_price`} name={`${row.productAddOns[0].cover[coverIndex + 1].productId}_product_actual_price`} value={row.productAddOns[0].cover[coverIndex + 1].price} />
                                                                <input type="hidden" name={`${row.categoryId}:coverId`} value={row.productAddOns[0].cover[coverIndex + 1].productId} />
                                                                <div><b>Actual Price: </b> {row.productAddOns[0].cover[coverIndex + 1].price}</div>
                                                                <TextFieldInList recordId={this.state.recordId} key={coverIndex + 1 + row.categoryId} id={`${row.productAddOns[0].cover[coverIndex + 1].productId}_product`} name={`${row.productAddOns[0].cover[coverIndex + 1].productId}_product`} disabled={(row.productAddOns[0].cover[coverIndex + 1].price <= 0 && row.productAddOns[0].cover[coverIndex + 1].discount <= row.productAddOns[0].cover[coverIndex + 1].price) ? true : false} error={row.productAddOns[0].cover[coverIndex + 1].discount > row.productAddOns[0].cover[coverIndex + 1].price} maxPrice={row.productAddOns[0].cover[coverIndex + 1].price} label="discount" initialPrice={row.productAddOns[0].cover[coverIndex + 1].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].cover[coverIndex + 1].price)} />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                            {coverIndex + 2 < row.productAddOns[0].cover.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAddOns[0].cover[coverIndex + 2].productId}_product_actual_price`} name={`${row.productAddOns[0].cover[coverIndex + 2].productId}_product_actual_price`} value={row.productAddOns[0].cover[coverIndex + 2].price} />
                                                                <input type="hidden" name={`${row.categoryId}:coverId`} value={row.productAddOns[0].cover[coverIndex + 2].productId} />
                                                                <div><b>Actual Price: </b> {row.productAddOns[0].cover[coverIndex + 2].price}</div>
                                                                <TextFieldInList recordId={this.state.recordId} key={coverIndex + 2 + row.categoryId} id={`${row.productAddOns[0].cover[coverIndex + 2].productId}_product`} name={`${row.productAddOns[0].cover[coverIndex + 2].productId}_product`} disabled={(row.productAddOns[0].cover[coverIndex + 2].price <= 0 && row.productAddOns[0].cover[coverIndex + 2].discount <= row.productAddOns[0].cover[coverIndex + 2].price) ? true : false} error={row.productAddOns[0].cover[coverIndex + 2].discount > row.productAddOns[0].cover[coverIndex + 2].price} maxPrice={row.productAddOns[0].cover[coverIndex + 2].price} label="discount" initialPrice={row.productAddOns[0].cover[coverIndex + 2].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].cover[coverIndex + 2].price)} />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                            {coverIndex + 3 < row.productAddOns[0].cover.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAddOns[0].cover[coverIndex + 3].productId}_product_actual_price`} name={`${row.productAddOns[0].cover[coverIndex + 3].productId}_product_actual_price`} value={row.productAddOns[0].cover[coverIndex + 3].price} />
                                                                <input type="hidden" name={`${row.categoryId}:coverId`} value={row.productAddOns[0].cover[coverIndex + 3].productId} />
                                                                <div><b>Actual Price: </b> {row.productAddOns[0].cover[coverIndex + 3].price}</div>
                                                                <TextFieldInList recordId={this.state.recordId} key={coverIndex + 3 + row.categoryId} id={`${row.productAddOns[0].cover[coverIndex + 3].productId}_product`} name={`${row.productAddOns[0].cover[coverIndex + 3].productId}_product`} disabled={(row.productAddOns[0].cover[coverIndex + 3].price <= 0 && row.productAddOns[0].cover[coverIndex + 3].discount <= row.productAddOns[0].cover[coverIndex + 3].price) ? true : false} error={row.productAddOns[0].cover[coverIndex + 3].discount > row.productAddOns[0].cover[coverIndex + 3].price} maxPrice={row.productAddOns[0].cover[coverIndex + 3].price} label="discount" initialPrice={row.productAddOns[0].cover[coverIndex + 3].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].cover[coverIndex + 3].price)} />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                          </TableRow>
                                                        </TableBody>
                                                      </>
                                                    ) : (<span />)}
                                                  </>
                                                );
                                              })}
                                            </Table>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableCell>
                                </TableRow>
                              )}
                              {/* Covers Ended */}

                              {/* Lamination Started */}
                              {(row.categoryId == 1 || row.categoryId == 2) && (
                                <TableRow>
                                  <TableCell>
                                    <Table style={{ border: "1px solid rgb(224 224 224)", borderBottom: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                      <TableHead>
                                        <TableRow className={classes.tableSubHeaderRow}>
                                          <TableCell align="left" className={classes.tableSubHeaderCell}>Lamination{" "}</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell>
                                            <Table style={{ border: "1px solid rgb(224 224 224)", borderBottom: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                              {row.productAddOns[0].lamination.map((lamination, laminationIndex) => {
                                                return (
                                                  <>
                                                    {laminationIndex % 4 === 0 ? (
                                                      <>
                                                        <TableHead>
                                                          <TableRow>
                                                            <TableCell align="left">{row.productAddOns[0].lamination[laminationIndex].userLabel}{" "}</TableCell>
                                                            {laminationIndex + 1 < row.productAddOns[0].lamination.length ? (<TableCell align="left">{row.productAddOns[0].lamination[laminationIndex + 1].userLabel}{" "}</TableCell>) : (<span />)}
                                                            {laminationIndex + 2 < row.productAddOns[0].lamination.length ? (<TableCell align="left">{row.productAddOns[0].lamination[laminationIndex + 2].userLabel}{" "}</TableCell>) : (<span />)}
                                                            {laminationIndex + 3 < row.productAddOns[0].lamination.length ? (<TableCell align="left">{row.productAddOns[0].lamination[laminationIndex + 3].userLabel}{" "}</TableCell>) : (<span />)}
                                                          </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                          <TableRow>
                                                            <TableCell align="left">
                                                              <input type="hidden" id={`${lamination.productId}_product_actual_price`} name={`${lamination.productId}_product_actual_price`} value={lamination.price} />
                                                              <input type="hidden" name={`${row.categoryId}:laminationId`} value={lamination.productId} />
                                                              <div><b>Actual Price: </b> {lamination.price}</div>
                                                              <TextFieldInList recordId={this.state.recordId} key={laminationIndex + row.categoryId} id={`${lamination.productId}_product`} name={`${lamination.productId}_product`} disabled={(lamination.price <= 0 && lamination.discount <= lamination.price)} maxPrice={lamination.price} label="discount" initialPrice={lamination.discount} error={lamination.discount > lamination.price} externalValue={this.getComputedDiscount(lamination.price)} />
                                                            </TableCell>
                                                            {laminationIndex + 1 < row.productAddOns[0].lamination.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAddOns[0].lamination[laminationIndex + 1].productId}_product_actual_price`} name={`${row.productAddOns[0].lamination[laminationIndex + 1].productId}_product_actual_price`} value={row.productAddOns[0].lamination[laminationIndex + 1].price} />
                                                                <input type="hidden" name={`${row.categoryId}:laminationId`} value={row.productAddOns[0].lamination[laminationIndex + 1].productId} />
                                                                <div><b>Actual Price: </b> {row.productAddOns[0].lamination[laminationIndex + 1].price}</div>
                                                                <TextFieldInList recordId={this.state.recordId} key={laminationIndex + 1 + row.categoryId} id={`${row.productAddOns[0].lamination[laminationIndex + 1].productId}_product`} name={`${row.productAddOns[0].lamination[laminationIndex + 1].productId}_product`} disabled={(row.productAddOns[0].lamination[laminationIndex + 1].price <= 0 && row.productAddOns[0].lamination[laminationIndex + 1].discount <= row.productAddOns[0].lamination[laminationIndex + 1].price)} maxPrice={row.productAddOns[0].lamination[laminationIndex + 1].price} error={row.productAddOns[0].lamination[laminationIndex + 1].discount > row.productAddOns[0].lamination[laminationIndex + 1].price} label="discount" initialPrice={row.productAddOns[0].lamination[laminationIndex + 1].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].lamination[laminationIndex + 1].price)} />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                            {laminationIndex + 2 < row.productAddOns[0].lamination.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAddOns[0].lamination[laminationIndex + 2].productId}_product_actual_price`} name={`${row.productAddOns[0].lamination[laminationIndex + 2].productId}_product_actual_price`} value={row.productAddOns[0].lamination[laminationIndex + 2].price} />
                                                                <input type="hidden" name={`${row.categoryId}:laminationId`} value={row.productAddOns[0].lamination[laminationIndex + 2].productId} />
                                                                <div><b>Actual Price: </b> {row.productAddOns[0].lamination[laminationIndex + 2].price}</div>
                                                                <TextFieldInList recordId={this.state.recordId} key={laminationIndex + 2 + row.categoryId} id={`${row.productAddOns[0].lamination[laminationIndex + 2].productId}_product`} name={`${row.productAddOns[0].lamination[laminationIndex + 2].productId}_product`} label="discount" disabled={(row.productAddOns[0].lamination[laminationIndex + 2].price <= 0 && row.productAddOns[0].lamination[laminationIndex + 2].discount <= row.productAddOns[0].lamination[laminationIndex + 2].price)} maxPrice={row.productAddOns[0].lamination[laminationIndex + 2].price} initialPrice={row.productAddOns[0].lamination[laminationIndex + 2].discount} error={row.productAddOns[0].lamination[laminationIndex + 2].discount > row.productAddOns[0].lamination[laminationIndex + 2].price} externalValue={this.getComputedDiscount(row.productAddOns[0].lamination[laminationIndex + 2].price)} />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                            {laminationIndex + 3 < row.productAddOns[0].lamination.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAddOns[0].lamination[laminationIndex + 3].productId}_product_actual_price`} name={`${row.productAddOns[0].lamination[laminationIndex + 3].productId}_product_actual_price`} value={row.productAddOns[0].lamination[laminationIndex + 3].price} />
                                                                <input type="hidden" name={`${row.categoryId}:laminationId`} value={row.productAddOns[0].lamination[laminationIndex + 3].productId} />
                                                                <div><b>Actual Price: </b> {row.productAddOns[0].lamination[laminationIndex + 3].price}</div>
                                                                <TextFieldInList recordId={this.state.recordId} key={laminationIndex + 3 + row.categoryId} id={`${row.productAddOns[0].lamination[laminationIndex + 3].productId}_product`} name={`${row.productAddOns[0].lamination[laminationIndex + 3].productId}_product`} disabled={(row.productAddOns[0].lamination[laminationIndex + 3].price <= 0 && row.productAddOns[0].lamination[laminationIndex + 3].discount <= row.productAddOns[0].lamination[laminationIndex + 3].price)} error={row.productAddOns[0].lamination[laminationIndex + 3].discount > row.productAddOns[0].lamination[laminationIndex + 3].price} maxPrice={row.productAddOns[0].lamination[laminationIndex + 3].price} label="discount" initialPrice={row.productAddOns[0].lamination[laminationIndex + 3].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].lamination[laminationIndex + 3].price)} />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                          </TableRow>
                                                        </TableBody>
                                                      </>
                                                    ) : (<span />)}
                                                  </>
                                                );
                                              })}
                                            </Table>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableCell>
                                </TableRow>
                              )}
                              {/* Lamination Ended */}
                            </>
                          ) : (<></>)}

                          {/* Pages Styles for Themed Photo Book & Mug Prints (categoryId == 2 || 9) */}
                          {row.categoryId == 2 || row.categoryId == 9 ? (
                            <>
                              <TableRow>
                                <TableCell>
                                  <Table style={{ border: "1px solid rgb(224 224 224)", borderBottom: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                    <TableHead>
                                      <TableRow className={classes.tableSubHeaderRow}>
                                        <TableCell className={classes.tableSubHeaderCell} align="left">
                                          {row.categoryId == 2 ? "Pages" : "Styles"}{" "}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="left">
                                          <Table style={{ border: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                            {row.productAttributes[0].styles.map((styles, pageTypesIndex) => {
                                              return (
                                                <>
                                                  {pageTypesIndex % 4 === 0 ? (
                                                    <>
                                                      <TableHead>
                                                        <TableRow>
                                                          <TableCell align="left">{row.productAttributes[0].styles[pageTypesIndex].userLabel}{" "}</TableCell>
                                                          {pageTypesIndex + 1 < row.productAttributes[0].styles.length ? (<TableCell align="left">{row.productAttributes[0].styles[pageTypesIndex + 1].userLabel}{" "}</TableCell>) : (<span />)}
                                                          {pageTypesIndex + 2 < row.productAttributes[0].styles.length ? (<TableCell align="left">{row.productAttributes[0].styles[pageTypesIndex + 2].userLabel}{" "}</TableCell>) : (<span />)}
                                                          {pageTypesIndex + 3 < row.productAttributes[0].styles.length ? (<TableCell align="left">{row.productAttributes[0].styles[pageTypesIndex + 3].userLabel}{" "}</TableCell>) : (<span />)}
                                                        </TableRow>
                                                      </TableHead>
                                                      <TableBody>
                                                        <TableRow>
                                                          <TableCell align="left">
                                                            <input type="hidden" id={`${styles.productId}_product_actual_price`} name={`${styles.productId}_product_actual_price`} value={styles.price} />
                                                            <input type="hidden" name={`${row.categoryId}:productStyleId`} value={styles.productId} />
                                                            <div><b>Actual Price: </b> {styles.price}</div>
                                                            <TextFieldInList recordId={this.state.recordId} key={pageTypesIndex + row.categoryId} id={`${styles.productId}_product`} name={`${styles.productId}_product`} disabled={(styles.price <= 0 && styles.discount <= styles.price) ? true : false} error={styles.discount > styles.price} maxPrice={styles.price} label="discount" initialPrice={styles.discount} externalValue={this.getComputedDiscount(styles.price)} />
                                                          </TableCell>
                                                          {pageTypesIndex + 1 < row.productAttributes[0].styles.length ? (
                                                            <TableCell align="left">
                                                              <input type="hidden" id={`${row.productAttributes[0].styles[pageTypesIndex + 1].productId}_product_actual_price`} name={`${row.productAttributes[0].styles[pageTypesIndex + 1].productId}_product_actual_price`} value={row.productAttributes[0].styles[pageTypesIndex + 1].price} />
                                                              <input type="hidden" name={`${row.categoryId}:productStyleId`} value={row.productAttributes[0].styles[pageTypesIndex + 1].productId} />
                                                              <div><b>Actual Price: </b> {row.productAttributes[0].styles[pageTypesIndex + 1].price}</div>
                                                              <TextFieldInList recordId={this.state.recordId} key={pageTypesIndex + 1 + row.categoryId} id={`${row.productAttributes[0].styles[pageTypesIndex + 1].productId}_product`} name={`${row.productAttributes[0].styles[pageTypesIndex + 1].productId}_product`} disabled={(row.productAttributes[0].styles[pageTypesIndex + 1].price <= 0 && row.productAttributes[0].styles[pageTypesIndex + 1].discount <= row.productAttributes[0].styles[pageTypesIndex + 1].price) ? true : false} error={row.productAttributes[0].styles[pageTypesIndex + 1].discount > row.productAttributes[0].styles[pageTypesIndex + 1].price} maxPrice={row.productAttributes[0].styles[pageTypesIndex + 1].price} label="discount" initialPrice={row.productAttributes[0].styles[pageTypesIndex + 1].discount} externalValue={this.getComputedDiscount(row.productAttributes[0].styles[pageTypesIndex + 1].price)} />
                                                            </TableCell>
                                                          ) : (<span />)}
                                                          {pageTypesIndex + 2 < row.productAttributes[0].styles.length ? (
                                                            <TableCell align="left">
                                                              <input type="hidden" id={`${row.productAttributes[0].styles[pageTypesIndex + 2].productId}_product_actual_price`} name={`${row.productAttributes[0].styles[pageTypesIndex + 2].productId}_product_actual_price`} value={row.productAttributes[0].styles[pageTypesIndex + 2].price} />
                                                              <input type="hidden" name={`${row.categoryId}:productStyleId`} value={row.productAttributes[0].styles[pageTypesIndex + 2].productId} />
                                                              <div><b>Actual Price: </b> {row.productAttributes[0].styles[pageTypesIndex + 2].price}</div>
                                                              <TextFieldInList recordId={this.state.recordId} key={pageTypesIndex + 2 + row.categoryId} id={`${row.productAttributes[0].styles[pageTypesIndex + 2].productId}_product`} name={`${row.productAttributes[0].styles[pageTypesIndex + 2].productId}_product`} disabled={(row.productAttributes[0].styles[pageTypesIndex + 2].price <= 0 && row.productAttributes[0].styles[pageTypesIndex + 2].discount <= row.productAttributes[0].styles[pageTypesIndex + 2].price) ? true : false} error={row.productAttributes[0].styles[pageTypesIndex + 2].discount > row.productAttributes[0].styles[pageTypesIndex + 2].price} maxPrice={row.productAttributes[0].styles[pageTypesIndex + 2].price} label="discount" initialPrice={row.productAttributes[0].styles[pageTypesIndex + 2].discount} externalValue={this.getComputedDiscount(row.productAttributes[0].styles[pageTypesIndex + 2].price)} />
                                                            </TableCell>
                                                          ) : (<span />)}
                                                          {pageTypesIndex + 3 < row.productAttributes[0].styles.length ? (
                                                            <TableCell align="left">
                                                              <input type="hidden" id={`${row.productAttributes[0].styles[pageTypesIndex + 3].productId}_product_actual_price`} name={`${row.productAttributes[0].styles[pageTypesIndex + 3].productId}_product_actual_price`} value={row.productAttributes[0].styles[pageTypesIndex + 3].price} />
                                                              <input type="hidden" name={`${row.categoryId}:productStyleId`} value={row.productAttributes[0].styles[pageTypesIndex + 3].productId} />
                                                              <div><b>Actual Price: </b> {row.productAttributes[0].styles[pageTypesIndex + 3].price}</div>
                                                              <TextFieldInList recordId={this.state.recordId} key={pageTypesIndex + 3 + row.categoryId} id={`${row.productAttributes[0].styles[pageTypesIndex + 3].productId}_product`} name={`${row.productAttributes[0].styles[pageTypesIndex + 3].productId}_product`} disabled={(row.productAttributes[0].styles[pageTypesIndex + 3].price <= 0 && row.productAttributes[0].styles[pageTypesIndex + 3].discount <= row.productAttributes[0].styles[pageTypesIndex + 3].price) ? true : false} error={row.productAttributes[0].styles[pageTypesIndex + 3].discount > row.productAttributes[0].styles[pageTypesIndex + 3].price} maxPrice={row.productAttributes[0].styles[pageTypesIndex + 3].price} label="discount" initialPrice={row.productAttributes[0].styles[pageTypesIndex + 3].discount} externalValue={this.getComputedDiscount(row.productAttributes[0].styles[pageTypesIndex + 3].price)} />
                                                            </TableCell>
                                                          ) : (<span />)}
                                                        </TableRow>
                                                      </TableBody>
                                                    </>
                                                  ) : (<span />)}
                                                </>
                                              );
                                            })}
                                          </Table>
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableCell>
                              </TableRow>

                              {/* Lamination for categoryId == 2 */}
                              {row.categoryId == 2 && (
                                <TableRow>
                                  <TableCell>
                                    <Table style={{ border: "1px solid rgb(224 224 224)", borderBottom: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                      <TableHead>
                                        <TableRow className={classes.tableSubHeaderRow}>
                                          <TableCell align="left" className={classes.tableSubHeaderCell}>Lamination{" "}</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell align="left">
                                            <Table style={{ border: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                              {row.productAddOns[0].lamination.map((lamination, laminationIndex) => {
                                                return (
                                                  <>
                                                    {laminationIndex % 4 === 0 ? (
                                                      <>
                                                        <TableHead>
                                                          <TableRow>
                                                            <TableCell align="left">{row.productAddOns[0].lamination[laminationIndex].userLabel}{" "}</TableCell>
                                                            {laminationIndex + 1 < row.productAddOns[0].lamination.length ? (<TableCell align="left">{row.productAddOns[0].lamination[laminationIndex + 1].userLabel}{" "}</TableCell>) : (<span />)}
                                                            {laminationIndex + 2 < row.productAddOns[0].lamination.length ? (<TableCell align="left">{row.productAddOns[0].lamination[laminationIndex + 2].userLabel}{" "}</TableCell>) : (<span />)}
                                                            {laminationIndex + 3 < row.productAddOns[0].lamination.length ? (<TableCell align="left">{row.productAddOns[0].lamination[laminationIndex + 3].userLabel}{" "}</TableCell>) : (<span />)}
                                                          </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                          <TableRow>
                                                            <TableCell align="left">
                                                              <input type="hidden" id={`${lamination.productId}_product_actual_price`} name={`${lamination.productId}_product_actual_price`} value={lamination.price} />
                                                              <input type="hidden" name={`${row.categoryId}:laminationId`} value={lamination.productId} />
                                                              <div><b>Actual Price: </b> {lamination.price}</div>
                                                              <TextFieldInList recordId={this.state.recordId} key={laminationIndex + row.categoryId} id={`${lamination.productId}_product`} name={`${lamination.productId}_product`} disabled={(lamination.price <= 0 && lamination.discount <= lamination.price) ? true : false} error={lamination.discount > lamination.price} maxPrice={lamination.price} label="discount" initialPrice={lamination.discount} externalValue={this.getComputedDiscount(lamination.price)} />
                                                            </TableCell>
                                                            {laminationIndex + 1 < row.productAddOns[0].lamination.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAddOns[0].lamination[laminationIndex + 1].productId}_product_actual_price`} name={`${row.productAddOns[0].lamination[laminationIndex + 1].productId}_product_actual_price`} value={row.productAddOns[0].lamination[laminationIndex + 1].price} />
                                                                <input type="hidden" name={`${row.categoryId}:laminationId`} value={row.productAddOns[0].lamination[laminationIndex + 1].productId} />
                                                                <div><b>Actual Price: </b> {row.productAddOns[0].lamination[laminationIndex + 1].price}</div>
                                                                <TextFieldInList recordId={this.state.recordId} key={laminationIndex + 1 + row.categoryId} id={`${row.productAddOns[0].lamination[laminationIndex + 1].productId}_product`} name={`${row.productAddOns[0].lamination[laminationIndex + 1].productId}_product`} disabled={(row.productAddOns[0].lamination[laminationIndex + 1].price <= 0 && row.productAddOns[0].lamination[laminationIndex + 1].discount <= row.productAddOns[0].lamination[laminationIndex + 1].price) ? true : false} error={row.productAddOns[0].lamination[laminationIndex + 1].discount > row.productAddOns[0].lamination[laminationIndex + 1].price} maxPrice={row.productAddOns[0].lamination[laminationIndex + 1].price} label="discount" initialPrice={row.productAddOns[0].lamination[laminationIndex + 1].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].lamination[laminationIndex + 1].price)} />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                            {laminationIndex + 2 < row.productAddOns[0].lamination.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAddOns[0].lamination[laminationIndex + 2].productId}_product_actual_price`} name={`${row.productAddOns[0].lamination[laminationIndex + 2].productId}_product_actual_price`} value={row.productAddOns[0].lamination[laminationIndex + 2].price} />
                                                                <input type="hidden" name={`${row.categoryId}:laminationId`} value={row.productAddOns[0].lamination[laminationIndex + 2].productId} />
                                                                <div><b>Actual Price: </b> {row.productAddOns[0].lamination[laminationIndex + 2].price}</div>
                                                                <TextFieldInList recordId={this.state.recordId} key={laminationIndex + 2 + row.categoryId} id={`${row.productAddOns[0].lamination[laminationIndex + 2].productId}_product`} name={`${row.productAddOns[0].lamination[laminationIndex + 2].productId}_product`} disabled={(row.productAddOns[0].lamination[laminationIndex + 2].price <= 0 && row.productAddOns[0].lamination[laminationIndex + 2].discount <= row.productAddOns[0].lamination[laminationIndex + 2].price) ? true : false} error={row.productAddOns[0].lamination[laminationIndex + 2].discount > row.productAddOns[0].lamination[laminationIndex + 2].price} maxPrice={row.productAddOns[0].lamination[laminationIndex + 2].price} label="discount" initialPrice={row.productAddOns[0].lamination[laminationIndex + 2].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].lamination[laminationIndex + 2].price)} />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                            {laminationIndex + 3 < row.productAddOns[0].lamination.length ? (
                                                              <TableCell align="left">
                                                                <input type="hidden" id={`${row.productAddOns[0].lamination[laminationIndex + 3].productId}_product_actual_price`} name={`${row.productAddOns[0].lamination[laminationIndex + 3].productId}_product_actual_price`} value={row.productAddOns[0].lamination[laminationIndex + 3].price} />
                                                                <input type="hidden" name={`${row.categoryId}:laminationId`} value={row.productAddOns[0].lamination[laminationIndex + 3].productId} />
                                                                <div><b>Actual Price: </b> {row.productAddOns[0].lamination[laminationIndex + 3].price}</div>
                                                                <TextFieldInList recordId={this.state.recordId} key={laminationIndex + 3 + row.categoryId} id={`${row.productAddOns[0].lamination[laminationIndex + 3].productId}_product`} name={`${row.productAddOns[0].lamination[laminationIndex + 3].productId}_product`} disabled={(row.productAddOns[0].lamination[laminationIndex + 3].price <= 0 && row.productAddOns[0].lamination[laminationIndex + 3].discount <= row.productAddOns[0].lamination[laminationIndex + 3].price) ? true : false} error={row.productAddOns[0].lamination[laminationIndex + 3].discount > row.productAddOns[0].lamination[laminationIndex + 3].price} maxPrice={row.productAddOns[0].lamination[laminationIndex + 3].price} label="discount" initialPrice={row.productAddOns[0].lamination[laminationIndex + 3].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].lamination[laminationIndex + 3].price)} />
                                                              </TableCell>
                                                            ) : (<span />)}
                                                          </TableRow>
                                                        </TableBody>
                                                      </>
                                                    ) : (<span />)}
                                                  </>
                                                );
                                              })}
                                            </Table>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableCell>
                                </TableRow>
                              )}
                            </>
                          ) : (<></>)}

                          {/* Bundle Started */}
                          {row.categoryId != 1 && row.categoryId != 2 && row.categoryId != 6 ? (
                            <TableRow>
                              <TableCell>
                                <Table style={{ border: "1px solid rgb(224 224 224)", borderBottom: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                  <TableHead>
                                    <TableRow className={classes.tableSubHeaderRow}>
                                      <TableCell align="left" className={classes.tableSubHeaderCell}>Bundles{" "}</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRow>
                                      <TableCell align="left">
                                        <Table style={{ border: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                          {row.productAttributes[0].bundles.map((bundle, bundleIndex) => {
                                            return (
                                              <>
                                                {bundleIndex % 4 === 0 ? (
                                                  <>
                                                    <TableHead>
                                                      <TableRow>
                                                        <TableCell align="left">{row.productAttributes[0].bundles[bundleIndex].userLabel}{" "}</TableCell>
                                                        {bundleIndex + 1 < row.productAttributes[0].bundles.length ? (<TableCell align="left">{row.productAttributes[0].bundles[bundleIndex + 1].userLabel}{" "}</TableCell>) : (<span />)}
                                                        {bundleIndex + 2 < row.productAttributes[0].bundles.length ? (<TableCell align="left">{row.productAttributes[0].bundles[bundleIndex + 2].userLabel}{" "}</TableCell>) : (<span />)}
                                                        {bundleIndex + 3 < row.productAttributes[0].bundles.length ? (<TableCell align="left">{row.productAttributes[0].bundles[bundleIndex + 3].userLabel}{" "}</TableCell>) : (<span />)}
                                                      </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                      <TableRow>
                                                        <TableCell align="left">
                                                          <input type="hidden" id={`${bundle.productId}_product_actual_price`} name={`${bundle.productId}_product_actual_price`} value={bundle.price} />
                                                          <input type="hidden" name={`${row.categoryId}:bundleId`} value={bundle.productId} />
                                                          <div><b>Actual Price: </b> {bundle.price}</div>
                                                          <TextFieldInList recordId={this.state.recordId} key={bundleIndex + row.categoryId} id={`${bundle.productId}_product`} name={`${bundle.productId}_product`} disabled={(bundle.price <= 0 && bundle.discount <= bundle.price) ? true : false} error={bundle.discount > bundle.price} maxPrice={bundle.price} label="discount" initialPrice={bundle.discount} externalValue={this.getComputedDiscount(bundle.price)} />
                                                        </TableCell>
                                                        {bundleIndex + 1 < row.productAttributes[0].bundles.length ? (
                                                          <TableCell align="left">
                                                            <input type="hidden" id={`${row.productAttributes[0].bundles[bundleIndex + 1].productId}_product_actual_price`} name={`${row.productAttributes[0].bundles[bundleIndex + 1].productId}_product_actual_price`} value={row.productAttributes[0].bundles[bundleIndex + 1].price} />
                                                            <input type="hidden" name={`${row.categoryId}:bundleId`} value={row.productAttributes[0].bundles[bundleIndex + 1].productId} />
                                                            <div><b>Actual Price: </b> {row.productAttributes[0].bundles[bundleIndex + 1].price}</div>
                                                            <TextFieldInList recordId={this.state.recordId} key={bundleIndex + 1 + row.categoryId} id={`${row.productAttributes[0].bundles[bundleIndex + 1].productId}_product`} name={`${row.productAttributes[0].bundles[bundleIndex + 1].productId}_product`} disabled={(row.productAttributes[0].bundles[bundleIndex + 1].price <= 0 && row.productAttributes[0].bundles[bundleIndex + 1].discount <= row.productAttributes[0].bundles[bundleIndex + 1].price) ? true : false} error={row.productAttributes[0].bundles[bundleIndex + 1].discount > row.productAttributes[0].bundles[bundleIndex + 1].price} maxPrice={row.productAttributes[0].bundles[bundleIndex + 1].price} label="discount" initialPrice={row.productAttributes[0].bundles[bundleIndex + 1].discount} externalValue={this.getComputedDiscount(row.productAttributes[0].bundles[bundleIndex + 1].price)} />
                                                          </TableCell>
                                                        ) : (<span />)}
                                                        {bundleIndex + 2 < row.productAttributes[0].bundles.length ? (
                                                          <TableCell align="left">
                                                            <input type="hidden" id={`${row.productAttributes[0].bundles[bundleIndex + 2].productId}_product_actual_price`} name={`${row.productAttributes[0].bundles[bundleIndex + 2].productId}_product_actual_price`} value={row.productAttributes[0].bundles[bundleIndex + 2].price} />
                                                            <input type="hidden" name={`${row.categoryId}:bundleId`} value={row.productAttributes[0].bundles[bundleIndex + 2].productId} />
                                                            <div><b>Actual Price: </b> {row.productAttributes[0].bundles[bundleIndex + 2].price}</div>
                                                            <TextFieldInList recordId={this.state.recordId} key={bundleIndex + 2 + row.categoryId} id={`${row.productAttributes[0].bundles[bundleIndex + 2].productId}_product`} name={`${row.productAttributes[0].bundles[bundleIndex + 2].productId}_product`} disabled={(row.productAttributes[0].bundles[bundleIndex + 2].price <= 0 && row.productAttributes[0].bundles[bundleIndex + 2].discount <= row.productAttributes[0].bundles[bundleIndex + 2].price) ? true : false} error={row.productAttributes[0].bundles[bundleIndex + 2].discount > row.productAttributes[0].bundles[bundleIndex + 2].price} maxPrice={row.productAttributes[0].bundles[bundleIndex + 2].price} label="discount" initialPrice={row.productAttributes[0].bundles[bundleIndex + 2].discount} externalValue={this.getComputedDiscount(row.productAttributes[0].bundles[bundleIndex + 2].price)} />
                                                          </TableCell>
                                                        ) : (<span />)}
                                                        {bundleIndex + 3 < row.productAttributes[0].bundles.length ? (
                                                          <TableCell align="left">
                                                            <input type="hidden" id={`${row.productAttributes[0].bundles[bundleIndex + 3].productId}_product_actual_price`} name={`${row.productAttributes[0].bundles[bundleIndex + 3].productId}_product_actual_price`} value={row.productAttributes[0].bundles[bundleIndex + 3].price} />
                                                            <input type="hidden" name={`${row.categoryId}:bundleId`} value={row.productAttributes[0].bundles[bundleIndex + 3].productId} />
                                                            <div><b>Actual Price: </b> {row.productAttributes[0].bundles[bundleIndex + 3].price}</div>
                                                            <TextFieldInList recordId={this.state.recordId} key={bundleIndex + 3 + row.categoryId} id={`${row.productAttributes[0].bundles[bundleIndex + 3].productId}_product`} name={`${row.productAttributes[0].bundles[bundleIndex + 3].productId}_product`} disabled={(row.productAttributes[0].bundles[bundleIndex + 3].price <= 0 && row.productAttributes[0].bundles[bundleIndex + 3].discount <= row.productAttributes[0].bundles[bundleIndex + 3].price) ? true : false} error={row.productAttributes[0].bundles[bundleIndex + 3].discount > row.productAttributes[0].bundles[bundleIndex + 3].price} maxPrice={row.productAttributes[0].bundles[bundleIndex + 3].price} label="discount" initialPrice={row.productAttributes[0].bundles[bundleIndex + 3].discount} externalValue={this.getComputedDiscount(row.productAttributes[0].bundles[bundleIndex + 3].price)} />
                                                          </TableCell>
                                                        ) : (<span />)}
                                                      </TableRow>
                                                    </TableBody>
                                                  </>
                                                ) : (<span />)}
                                              </>
                                            );
                                          })}
                                        </Table>
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableCell>
                            </TableRow>
                          ) : ("")}
                          {/* Bundle Ended */}

                          {/* Packaging Started */}
                          <TableRow>
                            <TableCell>
                              <Table style={{ border: "1px solid rgb(224 224 224)", borderBottom: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                <TableHead>
                                  <TableRow className={classes.tableSubHeaderRow}>
                                    <TableCell align="left" className={classes.tableSubHeaderCell}>Packaging{" "}</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell align="left">
                                      <Table style={{ border: "1px solid rgb(224 224 224)" }} aria-label="simple table">
                                        {row.productAddOns[0].packaging.map((packaging, packagingIndex) => {
                                          return (
                                            <>
                                              {packagingIndex % 4 === 0 ? (
                                                <>
                                                  <TableHead>
                                                    <TableRow>
                                                      <TableCell align="left">{row.productAddOns[0].packaging[packagingIndex].userLabel}{" "}</TableCell>
                                                      {packagingIndex + 1 < row.productAddOns[0].packaging.length ? (<TableCell align="left">{row.productAddOns[0].packaging[packagingIndex + 1].userLabel}{" "}</TableCell>) : (<span />)}
                                                      {packagingIndex + 2 < row.productAddOns[0].packaging.length ? (<TableCell align="left">{row.productAddOns[0].packaging[packagingIndex + 2].userLabel}{" "}</TableCell>) : (<span />)}
                                                      {packagingIndex + 3 < row.productAddOns[0].packaging.length ? (<TableCell align="left">{row.productAddOns[0].packaging[packagingIndex + 3].userLabel}{" "}</TableCell>) : (<span />)}
                                                    </TableRow>
                                                  </TableHead>
                                                  <TableBody>
                                                    <TableRow>
                                                      <TableCell align="left">
                                                        <input type="hidden" id={`${packaging.productId}_product_actual_price`} name={`${packaging.productId}_product_actual_price`} value={packaging.price} />
                                                        <input type="hidden" name={`${row.categoryId}:packagingId`} value={packaging.productId} />
                                                        <div><b>Actual Price: </b> {packaging.price}</div>
                                                        <TextFieldInList recordId={this.state.recordId} key={packagingIndex + row.categoryId} id={`${packaging.productId}_product`} name={`${packaging.productId}_product`} disabled={(packaging.price <= 0 && packaging.discount <= packaging.price) ? true : false} error={packaging.discount > packaging.price} maxPrice={packaging.price} label="discount" initialPrice={packaging.discount} externalValue={this.getComputedDiscount(packaging.price)} />
                                                      </TableCell>
                                                      {packagingIndex + 1 < row.productAddOns[0].packaging.length ? (
                                                        <TableCell align="left">
                                                          <input type="hidden" id={`${row.productAddOns[0].packaging[packagingIndex + 1].productId}_product_actual_price`} name={`${row.productAddOns[0].packaging[packagingIndex + 1].productId}_product_actual_price`} value={row.productAddOns[0].packaging[packagingIndex + 1].price} />
                                                          <input type="hidden" name={`${row.categoryId}:packagingId`} value={row.productAddOns[0].packaging[packagingIndex + 1].productId} />
                                                          <div><b>Actual Price: </b> {row.productAddOns[0].packaging[packagingIndex + 1].price}</div>
                                                          <TextFieldInList recordId={this.state.recordId} key={packagingIndex + 1 + row.categoryId} id={`${row.productAddOns[0].packaging[packagingIndex + 1].productId}_product`} name={`${row.productAddOns[0].packaging[packagingIndex + 1].productId}_product`} disabled={(row.productAddOns[0].packaging[packagingIndex + 1].price <= 0 && row.productAddOns[0].packaging[packagingIndex + 1].discount <= row.productAddOns[0].packaging[packagingIndex + 1].price) ? true : false} error={row.productAddOns[0].packaging[packagingIndex + 1].discount > row.productAddOns[0].packaging[packagingIndex + 1].price} maxPrice={row.productAddOns[0].packaging[packagingIndex + 1].price} label="discount" initialPrice={row.productAddOns[0].packaging[packagingIndex + 1].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].packaging[packagingIndex + 1].price)} />
                                                        </TableCell>
                                                      ) : (<span />)}
                                                      {packagingIndex + 2 < row.productAddOns[0].packaging.length ? (
                                                        <TableCell align="left">
                                                          <input type="hidden" id={`${row.productAddOns[0].packaging[packagingIndex + 2].productId}_product_actual_price`} name={`${row.productAddOns[0].packaging[packagingIndex + 2].productId}_product_actual_price`} value={row.productAddOns[0].packaging[packagingIndex + 2].price} />
                                                          <input type="hidden" name={`${row.categoryId}:packagingId`} value={row.productAddOns[0].packaging[packagingIndex + 2].productId} />
                                                          <div><b>Actual Price: </b> {row.productAddOns[0].packaging[packagingIndex + 2].price}</div>
                                                          <TextFieldInList recordId={this.state.recordId} key={packagingIndex + 2 + row.categoryId} id={`${row.productAddOns[0].packaging[packagingIndex + 2].productId}_product`} name={`${row.productAddOns[0].packaging[packagingIndex + 2].productId}_product`} disabled={(row.productAddOns[0].packaging[packagingIndex + 2].price <= 0 && row.productAddOns[0].packaging[packagingIndex + 2].discount <= row.productAddOns[0].packaging[packagingIndex + 2].price) ? true : false} error={row.productAddOns[0].packaging[packagingIndex + 2].discount > row.productAddOns[0].packaging[packagingIndex + 2].price} maxPrice={row.productAddOns[0].packaging[packagingIndex + 2].price} label="discount" initialPrice={row.productAddOns[0].packaging[packagingIndex + 2].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].packaging[packagingIndex + 2].price)} />
                                                        </TableCell>
                                                      ) : (<span />)}
                                                      {packagingIndex + 3 < row.productAddOns[0].packaging.length ? (
                                                        <TableCell align="left">
                                                          <input type="hidden" id={`${row.productAddOns[0].packaging[packagingIndex + 3].productId}_product_actual_price`} name={`${row.productAddOns[0].packaging[packagingIndex + 3].productId}_product_actual_price`} value={row.productAddOns[0].packaging[packagingIndex + 3].price} />
                                                          <input type="hidden" name={`${row.categoryId}:packagingId`} value={row.productAddOns[0].packaging[packagingIndex + 3].productId} />
                                                          <div><b>Actual Price: </b> {row.productAddOns[0].packaging[packagingIndex + 3].price}</div>
                                                          <TextFieldInList recordId={this.state.recordId} key={packagingIndex + 3 + row.categoryId} id={`${row.productAddOns[0].packaging[packagingIndex + 3].productId}_product`} name={`${row.productAddOns[0].packaging[packagingIndex + 3].productId}_product`} disabled={(row.productAddOns[0].packaging[packagingIndex + 3].price <= 0 && row.productAddOns[0].packaging[packagingIndex + 3].discount <= row.productAddOns[0].packaging[packagingIndex + 3].price) ? true : false} error={row.productAddOns[0].packaging[packagingIndex + 3].discount > row.productAddOns[0].packaging[packagingIndex + 3].price} maxPrice={row.productAddOns[0].packaging[packagingIndex + 3].price} label="discount" initialPrice={row.productAddOns[0].packaging[packagingIndex + 3].discount} externalValue={this.getComputedDiscount(row.productAddOns[0].packaging[packagingIndex + 3].price)} />
                                                        </TableCell>
                                                      ) : (<span />)}
                                                    </TableRow>
                                                  </TableBody>
                                                </>
                                              ) : (<span />)}
                                            </>
                                          );
                                        })}
                                      </Table>
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableCell>
                          </TableRow>
                          {/* Packaging Ended */}
                        </TableBody>
                      </Table>
                    ))}
                  </TableContainer>
                )}
              </div>
            </form>
          </Card>
          <BottomBar
            leftButtonAction={() => this.viewReport()}
            leftButtonText="View"
            rightButtonDisable={
              this.state.isLoading ||
              this.state.isDataLoading ||
              this.state.isSubmitLoading ||
              IsEmpty(discountCategoriesList)
            }
            rightButtonText={
              "Submit"
            }
            rightButtonAction={() => this.submitPrice()}
          />
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
            autoHideDuration={3000}
          />
          <Backdrop style={{ zIndex: 1500, color: '#fff' }} open={this.state.isSubmitLoading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Grid>
      </Fragment>
    );
  }
}

F301GeneralDiscountFormV4.propTypes = {
  classes: PropTypes.object,
  match: PropTypes.object,
};

F301GeneralDiscountFormV4.defaultProps = {
  classes: {},
  match: {
    params: {
      recordId: 0,
    },
  },
};

export default withStyles(useStyles)(F301GeneralDiscountFormV4);